import React from 'react';
import { Search } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const FILTER_OPTIONS = [
  { key: 'all', label: 'Todas' },
  { key: 'draft', label: 'Borradores' },
  { key: 'paid', label: 'Pagadas' },
  { key: 'published', label: 'Publicadas' },
  { key: 'requests', label: 'Pendientes de publicacion' },
];

export const AdminFiltersBar = ({ searchTerm, filterStatus, onSearchChange, onFilterChange }) => {
  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input
                placeholder="Buscar por licencia o nombre..."
                value={searchTerm}
                onChange={(event) => onSearchChange(event.target.value)}
                className="pl-10"
              />
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            {FILTER_OPTIONS.map((option) => (
              <Button
                key={option.key}
                variant={filterStatus === option.key ? 'default' : 'outline'}
                onClick={() => onFilterChange(option.key)}
              >
                {option.label}
              </Button>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
